export const GET_GENERAL_INFOS = (state) => state.GeneralInfos;
export const GET_PRODUCTS = (state) => state.Products;
export const GET_IMAGES = (state) => state.Images;
export const GET_SLIDE = (state) => state.Slides;
export const GET_KEYWORDS = (state) => state.Keywords;
export const GET_REFERENCES = (state) => state.References;
export const GET_VIDEO = (state) => state.Videos;
export const GET_SOCIAL = (state) => state.Social;